import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Form, Image, Card } from "react-bootstrap";
import { addReview } from "../../../redux/reviewSlice";
import { toast } from "react-toastify";
import RatingStar from "../RatingStar/RatingStar";

const ReviewModal = ({ show, handleClose, product, userId, orderId, currentRating }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("currentRating", currentRating);
  }
  const apiUrl = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const { success, error, loading, message } = useSelector((state) => state.review);
  const [rating, setRating] = useState(currentRating);

  const [userReview, setUserReview] = useState({
    userId,
    orderId,
    productId: product._id,
    rating: currentRating,
    review: "",
    images: [],
  });

  if (process.env.NODE_ENV === "development") {
    console.log("userReview", userReview, product);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserReview({ ...userReview, [name]: value });
  };


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setUserReview({ ...userReview, images: files });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(userReview).forEach(([key, value]) => {
      if (key === "images") {
        value.forEach((img) => data.append("images", img));
      } else {
        data.append(key, value);
      }
    })
    await dispatch(addReview(data)).unwrap()
      .then(() => {
        toast.success("Review added successfully!");
        handleClose();
      })
      .catch((err) => {
        toast.error(err?.message || "Something went wrong!");
      });

  }
  useEffect(() => {
    return () => {
      userReview.images.forEach((img) => {
        if (img instanceof File) {
          URL.revokeObjectURL(img);
        }
      });
    };
  }, [userReview.images]);

  useEffect(() => {
    setUserReview((prev) => ({ ...prev, rating }));
  }, [rating]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Write Review</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex align-items-center">
          <Image
            // src={`${apiUrl}${product.images[0]}` || "https://via.placeholder.com/50"}
            src={product.images?.[0] ? `${apiUrl}${product.images[0]}` : "https://via.placeholder.com/50"}
            roundedCircle
            width={50}
            height={50}
            className="me-2"
            style={{ objectFit: "cover" }}
          />
          <h6 className="mb-0">{product.name}</h6>
        </div>

        <div className="mt-3">
          <RatingStar onRatingChange={setRating} initialRating={currentRating} />
        </div>

        <Form.Group className="mt-3">
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Please write product review here."
            name="review"
            value={userReview.review}
            onChange={handleChange}
          />
        </Form.Group>

        <div className="mt-3 d-flex align-items-center">
          <label htmlFor="upload-image" className="border p-2 rounded">
            <input
              type="file"
              id="upload-image"
              className="d-none"
              onChange={handleImageChange}
              multiple
            />
            📷 Add Photos
          </label>
          {userReview.images.length > 0 &&
            userReview.images.map((img, index) => (
              <Card key={index} style={{ width: "100px", position: "relative", marginRight: "10px" }}>
                <Card.Img
                  variant="top"
                  src={img instanceof File ? URL.createObjectURL(img) : img}
                  alt="Preview"
                  style={{ height: "100px", objectFit: "cover" }}
                />
                <Button
                  variant="danger"
                  size="sm"
                  style={{ position: "absolute", top: 2, right: 2 }}
                  onClick={() =>
                    setUserReview({
                      ...userReview,
                      images: userReview.images.filter((_, i) => i !== index),
                    })
                  }
                >
                  ×
                </Button>
              </Card>
            ))}
        </div>

        <p className="text-muted mt-2" style={{ fontSize: "12px" }}>
          By submitting a review, you agree to our{" "}
          <a href="#">Terms of Use</a> and <a href="#">Privacy Policy</a>.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleSubmit}
          disabled={loading || !userReview.review.trim() || rating === 0}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal >
  );
};

export default ReviewModal;